var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 45.5C12.64 45.5 3 35.86 3 24C3 12.14 12.64 2.5 24.5 2.5C36.36 2.5 46 12.14 46 24C46 35.86 36.36 45.5 24.5 45.5ZM24.5 5.5C14.3 5.5 6 13.8 6 24C6 34.2 14.3 42.5 24.5 42.5C34.7 42.5 43 34.2 43 24C43 13.8 34.7 5.5 24.5 5.5Z",
    fill: "#008908"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6599 31.16C21.2599 31.16 20.8799 31 20.5999 30.72L14.9399 25.06C14.3599 24.48 14.3599 23.52 14.9399 22.94C15.5199 22.36 16.4799 22.36 17.0599 22.94L21.6599 27.54L31.9399 17.26C32.5199 16.68 33.4799 16.68 34.0599 17.26C34.6399 17.84 34.6399 18.8 34.0599 19.38L22.7199 30.72C22.4399 31 22.0599 31.16 21.6599 31.16Z",
    fill: "#008908"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.0456e52f.svg";
export { ForwardRef as ReactComponent };